module.exports = __webpack_public_path__ + "img/logo_full_inverted.19bdc25c.svg";